export default function IntroSection() {
	return (
		<section className="container pt-24">
			<div className="max-w-7xl mx-auto text-center">
				<p className="text-xl text-gray-300 max-w-3xl mx-auto">
					Be part of a company that's shaping the future of technology. We're looking for talented individuals who are passionate about innovation and excellence.
				</p>
				{/* <div className="flex flex-wrap gap-4 justify-center text-gray-300">
					<div className="flex items-center gap-2">
						<Users size={20} className="text-[#4A90E2]" />
						<span>20+ Team Members</span>
					</div>
					<div className="flex items-center gap-2">
						<MapPin size={20} className="text-[#4A90E2]" />
						<span>5 Global Locations</span>
					</div>
					<div className="flex items-center gap-2">
						<Briefcase size={20} className="text-[#4A90E2]" />
						<span>5+ Open Positions</span>
					</div>
				</div> */}
			</div>
		</section>
	);
}